import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/endpoints/")({
  beforeLoad: () => {
    throw redirect({ to: "/endpoints/ingest" });
  },
});
